import Vue from 'vue'
import Vuex from 'vuex'
import resultados from './Resultados'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    resultados
  },
  state: {
    url: false,
    dev: false,
    pow: false,
    admin: false,
    showConectores: false
  },
  mutations: {
    setURL (state, url) {
      state.url = url
    },
    setDev (state, value) {
      state.dev = value
    },
    setPow (state, value) {
      state.pow = value
    },
    setAdmin (state, value) {
      state.admin = value
    },
    setShowConectores (state, showConectores) {
      state.showConectores = showConectores
    }
  },
  getters: {
    getURL (state) {
      return (uri = false) => {
        return (uri) ? `${state.url}${uri}` : state.url
      }
    },
    isDev (state) {
      return state.dev
    },
    isPow (state) {
      return state.pow
    },
    isAdmin (state) {
      return state.admin
    },
    showConectores (state) {
      return state.showConectores
    }
  }
})
